// react
import React from 'react';
import { YouTube, Instagram, WhatsApp } from '@mui/icons-material';

export default function FooterPembayaran() {
    return (
        <div className="site-footer__widget footer-payments-social">
            {/* Pembayaran */}
            <div className="footer-sub-section">
                <h5 className="footer-title">Pembayaran</h5>
                <div className="footer-payment-list">
                    <div className="payment-badge" title="Bank Mandiri">
                        <img
                            src={`${process.env.PUBLIC_URL || ''}/images/payments/mandiri.png`}
                            alt="Mandiri"
                            loading="lazy"
                        />
                    </div>
                    <div className="payment-badge" title="Bank BCA">
                        <img
                            src={`${process.env.PUBLIC_URL || ''}/images/payments/bca.png`}
                            alt="BCA"
                            loading="lazy"
                        />
                    </div>
                    <div className="payment-badge" title="Bank BRI">
                        <img
                            src={`${process.env.PUBLIC_URL || ''}/images/payments/bri.svg`}
                            alt="Bank BRI"
                            loading="lazy"
                        />
                    </div>
                    <div className="payment-badge" title="Bank Jatim">
                        <img
                            src={`${process.env.PUBLIC_URL || ''}/images/payments/bankjatim.svg`}
                            alt="Bank Jatim"
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>

            {/* Sosial Media */}
            <div className="footer-sub-section mt-4">
                <h5 className="footer-title">Ikuti Kami</h5>
                <div className="footer-social-icons">
                    <a
                        href="https://www.instagram.com/hokkybangunan.sby"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon-btn"
                        aria-label="Instagram"
                        title="Instagram Hokky Bangunan"
                    >
                        <Instagram fontSize="small" />
                    </a>
                    <a
                        href="https://www.youtube.com/@hokkybangunan6207"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon-btn"
                        aria-label="YouTube"
                        title="YouTube Hokky Bangunan"
                    >
                        <YouTube fontSize="small" />
                    </a>
                    <a
                        href="https://api.whatsapp.com/send/?phone=+6281230553236&text=Hallo%20Hokky%20Bangunan"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-icon-btn"
                        aria-label="WhatsApp"
                        title="WhatsApp Hokky Bangunan"
                    >
                        <WhatsApp fontSize="small" />
                    </a>
                </div>
            </div>
        </div>
    );
}
